import { createFileRoute } from '@tanstack/react-router';

// Renders nothing: the widget lives on the parent route (see n._auth.feature-requests.tsx)
export const Route = createFileRoute('/n/_auth/feature-requests/')({});
